import { DocumentType } from "../pages/employees/enums/document-type.enum";

export type ClientGender = 'unspecified' | 'male' | 'female' | 'other';

export enum ClientType {
    B2C = 'B2C',
    B2B = 'B2B',
}

export enum ClientTypeApi {
    Individual = 1,
    Company = 2,
}

export type ClientTypeInput = ClientType | 'b2c' | 'b2b' | 1 | 2 | '1' | '2' | null;

export interface ClientDto {
    id: number;
    email: string | null;
    phoneNumber: string;
    status?: 1 | 2 | '1' | '2';
    lastVisit?: string;
    documentType?: DocumentType;
    documentId?: string;
    address?: string;
    centerId: number;
    fullName?: string;
    clientFullName?: string;
    imageUrl?: string;

    receiveMaintenanceData: boolean;
    preferredContactMethod?: PreferredContactMethod;
    firstRegistrationDate?: string;
    gender?: ClientGender;
    birthday?: string | null;
    comments?: string;
    secondaryContactName?: string;
    secondaryContactPhone?: string;
    clientType?: ClientTypeInput;
    newClient?: boolean;
}

export interface PaginatedResponse<T> {
    items: T[];
    metadata: {
        currentPage: number;
        pageSize: number;
        totalPages: number;
        totalCount: number;
        hasPrevious: boolean;
        hasNext: boolean;
    };
}

export interface VehicleDto {
    id: number;
    brand: string;
    model: string;
    plate: string;
    year?: number;
    clientId: number;
}

export interface CreateClientDto {
    fullName: string;
    email: string | null;
    phoneNumber: string;
    documentType: DocumentType;
    documentId: string;
    address?: string;
    clientType?: ClientTypeApi;

    receiveMaintenanceData?: boolean;
    preferredContactMethod?: PreferredContactMethod;
    firstRegistrationDate?: string;
    gender?: ClientGender;
    birthday?: string;
    comments?: string;
    secondaryContactName?: string;
    secondaryContactPhone?: string;
}

export interface UpdateClientDto {
    fullName: string;
    email: string | null;
    phoneNumber: string;
    documentType: DocumentType;
    documentId: string;
    address?: string;
    clientType?: ClientTypeApi;

    receiveMaintenanceData?: boolean;
    preferredContactMethod?: PreferredContactMethod;
    firstRegistrationDate?: string;
    gender?: ClientGender;
    birthday?: string;
    comments?: string;
    secondaryContactName?: string;
    secondaryContactPhone?: string;
}

export enum PreferredContactMethod {
    Whatsapp = 1,
    Email = 2,
    PhoneNumber = 3
} 
